import styled from "styled-components"

export const BillingModalWrapper = styled.div<{
    show: boolean
}>`
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: ${(props) => (props.show ? 0 : "100%")};
    z-index: 10;
    overflow-y: scroll;
    background: ${(props) => props.theme.billingModalBackground};
    transition: left 350ms;
`
export const CloseButton = styled.div`
    position: absolute;
    top: 30px;
    left: 30px;
    z-index: 10;

    & > i {
        padding: 4px;
        font-weight: bold;
        border: solid 2px transparent;
        border-radius: 50%;
        opacity: 0.7;
        transition: ${(props) => props.theme.defaultTransition};
    }
    
    &:hover i {
        border-color: ${(props) => props.theme.modalCloseButtonBorderColor};
        transition: ${(props) => props.theme.defaultTransition};
        opacity: 1;
    }
`
export const BillingModalContentWrapper = styled.div`
    width: 100%;
    height: 100%;
    max-width: 1000px;
    margin: 0 auto;
    position: relative;
`
export const BillingModalTitle = styled.div`
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    padding: 40px 0;
    font-size: 40px;
    font-weight: bold;
    font-family: ${(props) => props.theme.openSans};
    color: ${(props) => props.theme.billingModalTitleColor};
`
export const BillingModalSubtitle = styled.div`
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    padding-bottom: 20px;
    font-size: 20px;
    font-family: ${(props) => props.theme.openSans};
    color: ${(props) => props.theme.billingModalSubtitleColor};
`
export const PaymentMessage = styled.div`
    margin-top: 30px;
    text-align: center;
`
